import React from 'react';

const SplashLogo = () => {
  return (
    <svg
      width="375"
      height="375"
      viewBox="0 0 375 375"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.7" cx="98.5" cy="121.5" r="10.5" fill="white" />
      <circle opacity="0.6" cx="66.5" cy="197.5" r="10.5" fill="white" />
      <circle opacity="0.4" cx="109.5" cy="258.5" r="10.5" fill="white" />
      <circle opacity="0.5" cx="268.5" cy="116.5" r="10.5" fill="white" />
      <circle opacity="0.3" cx="308.5" cy="176.5" r="10.5" fill="white" />
      <circle opacity="0.6" cx="272.5" cy="247.5" r="10.5" fill="white" />
      <g clipPath="url(#clip0_149_2141)">
        <mask
          id="mask0_149_2141"
          maskUnits="userSpaceOnUse"
          x="139"
          y="137"
          width="100"
          height="100"
        >
          <path d="M139 137H239V237H139V137Z" fill="white" />
        </mask>
        <g mask="url(#mask0_149_2141)">
          <path
            d="M203.32 237C209.961 237 218.972 235.319 228.29 228.542C230.771 226.738 230.94 223.193 228.888 220.912L227.841 219.748C225.789 217.467 222.299 217.331 219.749 219.039C206.041 228.226 192.719 223.429 188.312 219.317C187.931 218.931 188.158 218.273 188.696 218.202C203.954 216.166 214.981 205.477 215.762 204.704C227.983 192.667 230.762 176.338 222.062 167.496C213.362 158.654 197 161.154 184.771 173.15C183.924 173.96 176.3 181.438 171.99 191.85C170.391 195.712 165.468 197.518 163.093 194.079C162.352 193.006 161.684 191.881 161.096 190.71C159.123 186.785 158.093 182.455 158.087 178.063C158.057 174.347 158.777 170.663 160.206 167.233C161.634 163.802 163.741 160.696 166.4 158.1C170.749 153.852 176.512 151.098 182.973 150.102C186.006 149.634 188.508 147.196 188.508 144.128V142.556C188.508 139.487 186.013 136.965 182.964 137.31C173.146 138.418 164.268 142.476 157.55 149.008C149.712 156.633 145.396 166.942 145.396 178.063C145.408 186.189 147.838 194.128 152.376 200.869C156.462 206.941 162.092 211.793 168.666 214.941C170.058 215.607 171.165 216.753 171.828 218.147C173.605 221.883 176.219 225.372 179.654 228.588C183.696 232.358 191.591 236.537 201.654 236.962C202.193 236.99 202.748 237.003 203.32 237ZM208.654 174.821C210.425 174.821 211.945 175.3 213.012 176.383C216.133 179.558 214.158 188.483 206.845 195.688L206.812 195.725C206.708 195.825 195.278 206.909 181.729 205.785C181.717 205.784 181.708 205.774 181.708 205.763C181.646 193.792 193.408 182.442 193.529 182.325L193.612 182.246C197.958 177.967 204.125 174.821 208.654 174.821Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_149_2141">
          <rect
            width="100"
            height="100"
            fill="white"
            transform="translate(139 137)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SplashLogo;
